var poll_default = {
  "fontElementMap": "_4agX0",
  "container": "VDu-t",
  "fullscreen": "_1kvm3",
  "background_overlay": "Is-B5",
  "with_image": "_346Q2",
  "options": "lsrdF",
  "webview": "S6iGN",
  "grid": "xHBuX",
  "option": "xfcbB",
  "cta_button": "Gn-lF",
  "add_option": "YxzFA",
  "see_more": "ABz-U",
  "list": "JnyER",
  "column": "jW673",
  "additional_note": "comC2",
  "spinner": "Qn5m9",
  "spin": "sKD6m",
  "shown": "g4ErS",
  "error": "LQ2Tc"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
